// extracted by mini-css-extract-plugin
module.exports = {"status":"AccreditationStatus_status__muT6F"};